<template>
	<div class="d-flex justify-content-center rounded bg-light mx-auto">

		<div class="card-body card-raised" style="max-width: 400px">
			<!-- <span class="d-none d-md-block float-right  ">
				<el-button class="d-flex flex-row align-items-center justify-content-center" type="text"
					@click="shareOnWhatsApp"><i style="color:rgb(2, 156, 2);font-size:x-large"
						class="fa fa-whatsapp"></i><span class="align-middle h-100" style="color: black;">
						SHARE</span></el-button></span>
			<span class=" d-block text-center">
				<el-button type="text" @click="downloadImageAndShare"><i style="color:gray;font-size:x-large"
						class="fa fa-download"></i> <span style="color: black;">Download And Copy</span></el-button></span> -->
			<div class="my-4 pt-2">
				<div id="HtmlContent" class="p-2 bg-light">
					<div class="bg-white py-4" style="caption-side: top; text-align: center">
						<div class="text-uppercase font-weight-bold text-dark">
							<img style="width: 80px;" src="../../../../public/img/AtomX-orange2.png" alt="atomXlogo" />
						</div>
						<div class="text-uppercase  font-weight-bold text-dark">
							Pay Slip
						</div>
						<div>
							{{ event.name }} ({{ event.id }}), <span class="text-capitalize">{{
								event.locationCity }}</span>
							,
							<span class="text-nowrap" style="
										/* color: #6c757d; */
										margin: 0px;

										font-size: 14px;
										overflow: hidden;
										text-align: center !important;
										font-family: 'Montserrat',

											'Helvetica Neue', Arial, sans-serif;
									">
								{{
									details.date.split("T")[0] !==
									details.date.split("T")[0]
									? "\n" +
									getFormattedDate(details.createdAt)
									+
									" to " +
									getFormattedDate(details.createdAt)
									: getFormattedDate(details.createdAt)
								}}
							</span>
						</div>
					</div>
					<table id="payslip_table" class="table table-bordered bg-white m-4"
						style="border-spacing: 1px 2px; padding-bottom: 400px !important;">



						<tbody class="table-group-divider border-top-0">
							<tr class="table-secondary">
								<th scope="col" class="table-secondary font-weight-bold">
									TRANSACTIONS
								</th>
								<th scope="col" class="table-secondary font-weight-bold text-center">
									NET AMOUNT
								</th>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>ACTIVATIONS
								</td>
								<td class="text-right ">{{ details.activations }}</td>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>AMOUNT
								</td>
								<td class="text-right ">{{ details.amount }}</td>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>INVOICE AMOUNT
								</td>
								<td class="text-right ">{{ details.invoiceAmount }}</td>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>Invoice GST
								</td>
								<td class="text-right ">{{ details.invoiceGst }}</td>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>REVERSAL ACTIVATIONS
								</td>
								<td class="text-right ">{{ details.reversalActivationCounts }}</td>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>REVERSAL AMOUNT
								</td>
								<td class="text-right ">{{ details.reversalAmount }}</td>
							</tr>
						</tbody>
						<tbody class="border-top-0">
							<tr>
								<td>SERVICE FEE
								</td>
								<td class="text-right ">{{ details.serviceFee }}</td>
							</tr>
						</tbody>
						<tbody class="table-secondary font-weight-bold border-top-0">
							<tr>
								<td>TRANSFER AMOUNT
								</td>
								<td class="text-right ">{{ details.transferAmount }}</td>
							</tr>
						</tbody>
					</table>
					<div style="font-size: xx-small;" class="mt-4 text-center text-uppercase text-sm text-dark">
						System-Generated: Confidential. For intended recipient only. Do not share without written consent
					</div>
				</div>
				<img id="img1" :src="imageUrl" class="d-none" />
			</div>

		</div>
	</div>
</template>
<script>
import { Card } from "@/components";
import {
	getBlobFromImageElement,
	copyBlobToClipboard,
} from "copy-image-clipboard";

import * as VueHtml2Image from "html-to-image";
import { copyText } from "vue3-clipboard";
import { toJpeg, toBlob } from "html-to-image";
import axios from "axios";
import { ElDivider, ElButton, ElMessage } from "element-plus";
import moment from "moment";

// import {
// 	getBlobFromImageElement,
// 	copyBlobToClipboard,
// } from "copy-image-clipboard";

export default {
	components: {
		Card,
		ElDivider,
		ElButton,
		copyText,
		getBlobFromImageElement,
		copyBlobToClipboard,
	},
	inject: ["$baseURL"],
	emits: ["loading-complete"],
	props: ["event", "details"],
	data() {
		return {
			defaultInfo: {},
			loginUser: {},
			isLoading: { dataDetails: true },
			imageUrl:
				"data:image/png;base64,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",
		};
	},
	methods: {
		getFormattedDate(dateString) {
			const date = new Date(dateString);
			date.setUTCHours(0, 0, 0, 0); // Set the time to midnight in UTC
			const year = date.getUTCFullYear();
			const monthNames = [
				"Jan", "Feb", "Mar", "Apr", "May", "Jun",
				"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
			];
			const monthName = monthNames[date.getUTCMonth()];
			const day = date.getUTCDate();
			return `${day} ${monthName} ${year}`;
		},
	},
	mounted() {
		// setTimeout(this.loadDetails, 500);
		let u = JSON.parse(localStorage.getItem("user"));
		this.loginUser = u;
		if (!u || Object.keys(u).length === 0 && u.constructor === Object)
			return this.$router.push("/login");
		// this.loadDetails();
	},
};
</script>
